import { useState, useEffect } from "react";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { CountryData } from "react-phone-input-2";
import "./styles.css";
import { useRegion } from "../../context/RegionContext";
import { REGIONS } from "../../constants/regions";

interface Props {
  handleChange: any;
}

const OnboardMobileInput = ({ handleChange }: Props) => {
  const { region } = useRegion();
  const [phone, setPhone] = useState("");

  // Auto-select country based on region
  const getDefaultCountry = (): string => {
    return region === REGIONS.AE ? "ae" : "sa";
  };

  const [country, setCountry] = useState(getDefaultCountry());

  // Update country when region changes
  useEffect(() => {
    const newCountry = region === REGIONS.AE ? "ae" : "sa";
    setCountry(newCountry);
  }, [region]);

  const handlePhoneChange = (value: string, country: CountryData) => {
    handleChange(value, country);
    setPhone(value);
    setCountry(country.countryCode?.toLowerCase() || "");
  };

  return (
    <PhoneInput
      country={country}
      value={phone}
      placeholder="Mobile Number*"
      onChange={handlePhoneChange}
      countryCodeEditable={false}
      inputStyle={{
        width: "100%",
        outline: "none",
        fontFamily: "IBM Plex Sans Condensed",
        fontStyle: "normal",
        fontSize: "14px",
        borderRadius: "10px",
        borderColor: "rgba(226, 232, 240, 1)",
        height: "55px",
      }}
      containerStyle={{
        height: "55px",
        outline: "none",
      }}
      buttonStyle={{
        borderRadius: "10px 0px 0px 10px",
      }}
      dropdownStyle={{
        height: "150px",
      }}
    />
  );
};

export default OnboardMobileInput;
